import { useProductContractHandoff } from "@/api/services/admin/product-contract";
import { Button } from "@/components/elements/Button";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { getCenterFrom, getDynamicRoute, redirectToCenter, withCenterFrom } from "@/utils/url";
import { Box, Container, Divider, Stack } from "@mui/material";
import { FC, Fragment } from "react";
import { Link, Navigate } from "react-router-dom";

type TOrganizationTypeOption = {
  key: string;
  label: string;
  to: string;
};

const ORGANIZATION_TYPE_OPTIONS: TOrganizationTypeOption[] = [
  {
    key: "rso",
    label: "登録支援機関",
    to: AppRoutes.rsoCreate,
  },
  {
    key: "company",
    label: "受け入れ企業",
    to: AppRoutes.companyCreate,
  },
];

type TOrganizationSelectTypePageProps = {};

export const OrganizationSelectTypePage: FC<TOrganizationSelectTypePageProps> = () => {
  const { canCreateRso, canCreateCompany, isLoading, contract } = useProductContractHandoff();
  // 遷移元のcenterパス。作成画面まで引き継ぎ、登録完了後にそこへ戻す。
  const centerFrom = getCenterFrom();

  if (isLoading) return <LoadingScreen />;
  if (!canCreateRso || !canCreateCompany) return <Navigate to={AppRoutes.pageNotFound} replace />;

  const handleBackToCenter = () => {
    if (centerFrom) {
      redirectToCenter(centerFrom);
      return;
    }
    if (!contract) {
      redirectToCenter("/organizations");
      return;
    }
    redirectToCenter(getDynamicRoute(`/organizations/:id`, { id: contract?.organizationId }));
  };

  return (
    <Box>
      <TopPage
        title="機関の新規登録"
        description="登録する機関の種別を選択してください。"
        enablePageBack={false}
        rightContent={
          <Button variant="outline" onClick={handleBackToCenter} data-testid="organization-type-back-to-center">
            centerシステム管理へ戻る
          </Button>
        }
      />
      <Container sx={{ minHeight: "70vh", display: "flex", alignItems: "center" }}>
        <Stack sx={{ width: "100%" }} direction="row" justifyContent="center" alignItems="center">
          {ORGANIZATION_TYPE_OPTIONS.map((option, index) => (
            <Fragment key={option.key}>
              {index > 0 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    borderColor: black[90],
                    marginRight: "162px",
                    marginLeft: "162px",
                  }}
                />
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button component={Link} variant="ghost" to={withCenterFrom(option.to, centerFrom)} data-testid={`organization-type-${option.key}`}>
                  {option.label}
                </Button>
              </Box>
            </Fragment>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};
